import { ComponentSizes, ContinueType, NodeTypes, TextContentHighlightMod, TextContentType, ChatbotNode } from '@myriadgenetics/mgh-types';
import { NODE_IDS } from '../constants';
import { getNextComponentId } from '../../../../helpers/components';

export const startNode: ChatbotNode = {
  id: NODE_IDS.START_NODE,
  name: 'Lang Selector Node',
  description: 'Start Node',
  type: NodeTypes.Chat,
  data: {
    continueType: ContinueType.AutoEnd,
    pageTitleKey: 'pageTitles.chatbot.lang',
  },
  components: [
    {
      id: getNextComponentId(),
      type: 'TEXT_CONTENT',
      name: 'Hello Intro',
      description: 'Example of chat',
      data: {
        contentKey: 'chatbot.start.welcome',
        type: TextContentType.Text1,
        highlightModifier: TextContentHighlightMod.Primary,
        delay: 0,
        avatarSvg: 'chatbot.hcpAvatar',
      },
    },
    {
      id: getNextComponentId(),
      description: 'Language Select Option',
      name: 'Language Select Options',
      type: 'OPTION_SELECT',
      data: {
        answerKey: 'language',
        questionKey: '',
        labelKey: '',
        placeholderKey: '',
        subtitleKey: '',
        required: true,
        isSingleSelect: true,
        optionSize: ComponentSizes.Medium,
        delay: 2000,
        // avatarSvg: patientAvatar,
        position: 'right',
        selectionOptions: [
          {
            optionKey: 1,
            optionValue: 'chatbot.language.en',
            optionSelectedDisplayKey: 'chatbot.language.selected',
          },
          {
            optionKey: 2,
            optionValue: 'chatbot.language.es',
            optionSelectedDisplayKey: 'chatbot.language.selected',
          },
        ],
      },
    },
  ],
  flows: [
    {
      id: -1,
      name: 'Unconditional',
      description: 'To Intro with terms',
      type: 'UNCONDITIONAL',
      data: {
        nextPageId: NODE_IDS.INTRO_WITH_TERMS_NODE,
      },
    },
  ],
};

export default startNode;
